import React, { useState, useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { ReviewsSection } from './components/ReviewsSection';
import { GallerySection } from './components/GallerySection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { BookingModal } from './components/BookingModal';
import { WhatsAppButton } from './components/WhatsAppButton';
import { AdminDashboard } from './components/AdminDashboard';
import { AdminLogin } from './components/AdminLogin';
import { Toaster } from './components/ui/sonner';

const MainWebsite = () => {
  const [isBookingOpen, setIsBookingOpen] = useState(false);

  const openBooking = () => setIsBookingOpen(true);
  const closeBooking = () => setIsBookingOpen(false);

  return (
    <div className="sirena-app" data-testid="sirena-app">
      <Navbar onBookClick={openBooking} />
      <main>
        <HeroSection onBookClick={openBooking} />
        <AboutSection />
        <ServicesSection />
        <ReviewsSection />
        <GallerySection />
        <ContactSection onBookClick={openBooking} />
      </main>
      <Footer />
      <WhatsAppButton />
      <BookingModal isOpen={isBookingOpen} onClose={closeBooking} />
    </div>
  );
};

const AdminPage = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Check if admin is logged in
    const loggedIn = sessionStorage.getItem('adminLoggedIn') === 'true';
    setIsLoggedIn(loggedIn);
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem('adminLoggedIn');
    setIsLoggedIn(false);
  };

  if (!isLoggedIn) {
    return (
      <AdminLogin 
        language={language} 
        onLoginSuccess={() => setIsLoggedIn(true)} 
      />
    );
  }

  return (
    <AdminDashboard 
      language={language} 
      onBack={() => navigate('/')}
      onLogout={handleLogout}
    />
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainWebsite />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
        <Toaster position="top-center" />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
